import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface IAuthStore {
  isLoggedInWithMeridian: boolean;
  authToken: string | null;
  refreshToken: string | null;
  codeVerifier: string | null;
  setCodeVerifier: (verifier: string | null) => void;
  setTokens: (authToken: string, refreshToken: string) => void;
  clearAuth: () => void;
}

const useAuthStore = create<IAuthStore>()(
  persist(
    (set) => ({
      isLoggedInWithMeridian: false,
      authToken: null,
      refreshToken: null,
      codeVerifier: null,
      setCodeVerifier: (verifier: string | null) => set({ codeVerifier: verifier }),
      setTokens: (authToken: string, refreshToken: string) =>
        set({ authToken, refreshToken, isLoggedInWithMeridian: true }),
      clearAuth: () =>
        set({
          isLoggedInWithMeridian: false,
          authToken: null,
          refreshToken: null,
          codeVerifier: null,
        }),
    }),
    {
      name: "meridian-oauth",
    }
  )
);

export default useAuthStore;

// Helper functions for non-React contexts (platform adapters, utilities, etc.)
export const getAuthToken = () => useAuthStore.getState().authToken;
export const getCodeVerifier = () => useAuthStore.getState().codeVerifier;
export const setAuthTokens = (authToken: string, refreshToken: string) =>
  useAuthStore.getState().setTokens(authToken, refreshToken);
export const setCodeVerifier = (verifier: string | null) =>
  useAuthStore.getState().setCodeVerifier(verifier);
export const clearAuthStore = () => useAuthStore.getState().clearAuth();
